import type { SxProps, Theme } from "@mui/material/styles";

export const root: SxProps<Theme> = (theme) => ({
  bgcolor: "background.paper",
  border: 1,
  borderColor: "divider",
  borderRadius: 3,
  boxShadow: theme.shadows[3],
  p: { xs: 5, md: 8.75 },
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 1.5,
  textAlign: "center",
  minHeight: { md: 420 },
});

export const mobileRoot: SxProps<Theme> = {
  flex: 1,
  display: { xs: "flex", md: "none" },
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 1.25,
  textAlign: "center",
  py: 5,
  px: 3,
};

export const iconWrap: SxProps<Theme> = {
  width: { xs: 80, md: 100 },
  height: { xs: 80, md: 100 },
  borderRadius: { xs: 2.75, md: 3.5 },
  bgcolor: { xs: "background.paper", md: "background.default" },
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  mb: 0.75,
};

export const title: SxProps<Theme> = {
  fontSize: { xs: "0.90625rem", md: "1.0625rem" },
  fontWeight: 700,
};

export const description: SxProps<Theme> = {
  fontSize: { xs: "0.75rem", md: "0.8125rem" },
  color: "text.secondary",
  maxWidth: 400,
  lineHeight: 1.8,
};

export const actionWrap: SxProps<Theme> = {
  mt: 1,
};
